<template>
  <AppAsideDialog v-bind="{ isOpened }" @close="close">
    <AppLogo class="mb-6 h-9 w-36" />
    <AccordionLinks
      v-bind="{
        navGroupList,
        openedKeys: ['menu.services'],
      }"
      class="mb-8"
      @link-click="close"
    />

    <div class="mt-auto">
      <div
        class="mb-24 grid grid-cols-2-max items-center justify-items-start gap-x-8 gap-y-5 text-lg leading-6"
      >
        <IntlMsg
          v-bind="{ k: 'footer.language' }"
          class="text-xl font-semibold leading-7"
        />
        <LocaleSelect v-bind="{ size: 'sm' }" />

        <IntlMsg
          v-bind="{ k: 'footer.currency' }"
          class="text-xl font-semibold leading-7"
        />
        <CurrencySelect v-bind="{ hasLabel: false }" />
      </div>
    </div>
  </AppAsideDialog>
</template>

<script lang="ts" setup>
import { onUnmounted, ref, computed } from 'vue'

import AccordionLinks from '/@/modules/app/accordion/AccordionLinks.vue'

import { bus, IntlMsg, type AppNavGroup } from '/@shared/app'
import {
  AppAsideDialog,
  AppLogo,
  LocaleSelect,
  CurrencySelect,
  useLocaleFeatures,
} from '/@app'

const isOpened = ref(false)

function close() {
  isOpened.value = false
}
function open() {
  isOpened.value = true
}

bus.on('app::show-mobile-menu', open)
onUnmounted(() => bus.off('app::show-mobile-menu', open))

const { isVpnAvailable } = useLocaleFeatures()

const navGroupList = computed(() => {
  const list: AppNavGroup[] = [
    {
      key: 'menu.services',
      children: [
        {
          to: { name: 'DsPage' },
          key: 'menu.dedicated',
        },
        {
          to: { name: 'VpsPage' },
          key: 'menu.vps',
        },
        {
          to: { name: 'VhPage' },
          key: 'menu.hosting',
        },
        {
          to: { name: 'BackupPage' },
          key: 'menu.backup',
        },
      ],
    },
  ]

  if (isVpnAvailable.value)
    list[0].children.push({
      to: { name: 'VpnPage' },
      key: 'menu.vpn',
    })

  list.push(
    {
      key: 'menu.resources',
      children: [
        {
          to: { name: 'HelpIndexPage' },
          key: 'menu.help',
        },
        {
          to: { name: 'HelpArticlePage', params: { slug: 'partner-program' } },
          key: 'menu.for-partners',
        },
        {
          to: { name: 'ApiPage' },
          key: 'menu.api',
        },
        {
          to: 'https://x.com/fornex_com',
          key: 'socials.twitter',
        },
        {
          to: 'https://t.me/fornex_hosting',
          key: 'socials.telegram-channel',
        },
      ],
    },
    {
      key: 'menu.company',
      children: [
        {
          to: { name: 'NewsPage' },
          key: 'menu.news',
        },
        {
          to: { name: 'ServicesPage' },
          key: 'menu.our-services',
        },
        {
          to: {
            name: 'HomePage',
            hash: '#ourclients',
          },
          key: 'menu.our-customers',
        },
        {
          to: { name: 'ContactsPage' },
          key: 'menu.contacts',
        },
      ],
    }
  )

  return list
})
</script>
